import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { misc, neutral } from "app/themes/colors";

import EditIcon from "@mui/icons-material/Edit";
import { colord } from "colord";
import { PatientNote } from "services/types/patient-notes.type";
import NoteIcon from "@mui/icons-material/Note";
import DeleteIcon from "@mui/icons-material/Delete";

import { format } from "date-fns";
type NotePreviewProps = {
  note: PatientNote;
  onDelete?: (note: PatientNote) => void;
  onEdit?: (task: PatientNote) => void;
};
export default function NotePreview({
  note,
  onDelete,
  onEdit,
}: NotePreviewProps) {
  const { title, description, created_by, created_at } = note;
  const margin = { mr: 1.5 };
  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        "&:first-of-type": {
          mt: -3,
        },
        px: 0.5,
        py: 2.5,
        borderBottom: `dashed 1px ${misc.darkGreen}`,
        overflow: "hidden",
      }}
    >
      <Stack sx={{ width: "42px" }}>
        <Box sx={{ ...margin }}>
          <IconButton size="small">
            <NoteIcon
              htmlColor={colord(misc.darkYellow).darken(0.15).toHex()}
            />
          </IconButton>
        </Box>
      </Stack>

      <Stack width="100%">
        <Grid container direction="row">
          <Grid item xs={6.5}>
            <Typography
              variant="body2"
              fontWeight={800}
              sx={{
                color: colord(misc.darkYellow).darken(0.25).toHex(),
                mb: 0.5,
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: misc.grayAsphalt, whiteSpace: "pre-line" }}
            >
              {description}
            </Typography>
          </Grid>

          <Grid item xs={3.5}>
            <Typography
              variant="body2"
              sx={{
                width: "100%",
                color: misc.blackAsphalt,
                fontSize: "12px",
                lineHeight: 1.2,
                textAlign: "right",
                mb: 0.5,
              }}
            >
              {created_by?.fullName ? `by ${created_by.fullName}` : ""}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: neutral[700],
                fontSize: "9px",
                transform: "scale(1.05)",
                width: "100%",
                lineHeight: 1.3,
                textAlign: "right",
              }}
            >
              {format(new Date(String(created_at)), "MMM dd, yyyy hh:mm aaa")}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            {onDelete && (
              <IconButton
                sx={{ mt: -1, opacity: 0.7 }}
                size="small"
                onClick={() => onDelete(note)}
              >
                <DeleteIcon sx={{ fontSize: "20px" }} />
              </IconButton>
            )}
            {onEdit && (
              <IconButton
                sx={{ opacity: 0.7 }}
                size="small"
                onClick={() => onEdit(note)}
              >
                <EditIcon sx={{ fontSize: "20px" }} />
              </IconButton>
            )}
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
}
